module.exports = __webpack_public_path__ + "img/teacher2-1.799f8eca.png";